import { Route, Routes } from 'react-router-dom'
import Layout from '../layout/Layout'
import Home from '../pages/Home'
import Login from '../pages/Login'
import { checkTokenValidity } from '../utils/checkTokenValidity'
import { Navigate } from 'react-router'

import NoPage from '../pages/NoPage'

import ContractsPage from '../pages/admin/ContractsPage'
import DaisyMainPage from '../pages/admin/DaisyMainPage'
import HPMMainPage from '../pages/admin/HPMMainPage'
import UserManager from '../pages/admin/UserManager'
import GroupManager from '../pages/admin/GroupManager'
import CompanyDetails from '../pages/admin/CompanyDetails'
import ContractHistory from '../components/contract/ContractHistory'
import OrgManager from '../pages/admin/OrgManager'
import MiningMachine from '../pages/admin/MiningMachine'
import NewsManager from '../pages/admin/NewsManager'
import HumanGold from '../pages/admin/HumanGold'
import Vote from '../pages/admin/Vote'
import { TopListTable } from '../pages/admin/TopList'
import MyMiningMachine from '../components/miningmachine/MyMiningMachine'
import MiningMachineTypeManager from '../components/miningmachine/MiningMachineTypeManager'
import GroupConnectionsList from '../components/group/subcomponents/GroupConnectionsList'
import DepositRegisterPage from '../pages/admin/DepositRegisterPage'
import NewsLetterPanel from '../pages/admin/NewsLetter'
import PurchaseCoinsPanel from '../components/humandc/subcomponents/tables/deposit/PurchaseCoinsPanel'
import MinedCoinTraderPanel from '../components/humandc/extensions/minedcoinstrading/MinedCoinTraderPanel'
import LeveragedTrading from '../pages/admin/LeveragedTrading'
import PayoutRegisterPage from '../components/humandc/subcomponents/tables/deposit/PayoutRegisterPage'
import DaisyPayoutManager from '../pages/admin/DaisyPayoutManager'
import TotalDaisyPayoutManager from '../pages/admin/TotalDaisyPayoutManager'
import NewsLetterManagerList from '../pages/admin/NewsLetterManagerList'
import VoteLabelManager from '../pages/admin/VoteLabelManager'
import BraveSimulation from '../pages/admin/protocol/BraveSimulation'
import HumanNewSimulation from '../pages/admin/protocol/HumanNewSimulation'
import ProtokolTopList from '../pages/admin/protocol/ProtokolTopList'
import MiningMachineExpires from '../components/miningmachine/MiningMachineExpires'
import HumanPayouts from '../pages/admin/HumanPayouts'
import DaisyDepositInterval from '../pages/admin/DaisyDepositInterval'
import MiningProductionDashboardPage from '../pages/admin/MiningProductionDashboardPage'
import NewsLetterSubscriptionHandler from '../pages/admin/NewsLetterSubscriptionHandler'
import ReturnAfterDocuSignPage from '../pages/admin/ReturnAfterDocuSignPage'
import DaisyDepositInvervalContractList from '../pages/admin/DaisyDepositInvervalContractList'
import LargeBitcoinChartPage from '../pages/admin/LargeBitcoinChartPage'
import MiningalternativePage from '../components/miningmachine/miningalternative/MiningalternativePage'
import BlockchainSportsAdminPage from '../pages/admin/BlockchainSportsAdminPage'
import DashboardCaptionCreator from '../pages/admin/DashboardCaptionCreator'
import AccountHandling from '../pages/admin/AccountHandling'
import DaisyEurRatesPage from '../pages/admin/DaisyEurRatesPage'
import DaisyPayoutsMainPage from '../pages/admin/DaisyPayoutsMainPage'
import { BMPDashboard } from '../pages/admin/BMPDashboard'
import NewsLetterViewers from '../pages/admin/NewsLetterViewers'
import UserMap from '../pages/admin/UserMap'
import MeetingList from '../pages/admin/MeetingList'
import FHPMMainPage from '../pages/admin/FHPMMainPage'
import TaskPage from '../pages/admin/TaskPage'
import DaisyAtlaOptionsPage from '../pages/admin/DaisyAtlaOptionsPage'
import { HumanThirdPage } from '../pages/admin/HumanThirdPage'
export default function Router() {

  const isAuthenticated = checkTokenValidity(); // Function to check the validity of JWT token

  return (
    <Routes>
      <Route path="/login" element={isAuthenticated ? <Navigate to="/" /> : <Login />} />
      
      <Route path="/" element={<Layout />}>
        <Route index element={isAuthenticated ? <Home /> : <Navigate to="/login" />} />
        {isAuthenticated ?
        <>
          <Route path="daisy" element={<DaisyMainPage />} />
          <Route path="newsletter" element={<NewsLetterPanel />} />
          <Route path="hpm" element={<HPMMainPage />} />
          <Route path="fhpm" element={<FHPMMainPage />} />
          <Route path="hpm-third" element={<HumanThirdPage />} />
          <Route path="miningmachines" element={<MiningMachine flag={false}/>} />
          <Route path="allmachine" element={<MiningMachine flag={true}/>} />
          <Route path="gold" element={<HumanGold />} />
          <Route path="miningalternative" element={<MiningalternativePage />} />
          <Route path="altcoin" element={<HPMMainPage />} />
          <Route path="leverage" element={<LeveragedTrading />} />
          <Route path="contracts" element={<ContractsPage />} />
          <Route path="group-manager" element={<GroupManager />} />
          <Route path="manager" element={<UserManager />} />
          <Route path="orgmanager" element={<OrgManager />} />
          <Route path="company" element={<CompanyDetails />} />
          <Route path="depositregister" element={<DepositRegisterPage/>} />
          <Route path="newsmanager" element={<NewsManager />} />
          <Route path="toplist" element={<TopListTable />} />
          <Route path="vote" element={<Vote />} />
          <Route path="/myminingmachine/:id" element={<MyMiningMachine/>} />
          <Route path="/cp/:id" element={<PurchaseCoinsPanel />} />
          <Route path="/hcp/:id" element={<PurchaseCoinsPanel mode="holding" />} />
          <Route path="/payoutmanager/:id" element={<PayoutRegisterPage/>} />
          <Route path="/miningmachinesdaily" element={<MiningMachineTypeManager/>} />
          <Route path="/miningmachinesexpiration" element={<MiningMachineExpires/>} />
          <Route path="/minedtrading" element={<MinedCoinTraderPanel/>} />
          <Route path="/protokol" element={<HumanNewSimulation/>} />
          <Route path="/bravedetails" element={<BraveSimulation/>} />
          <Route path="/simlist" element={<ProtokolTopList/>} />
          <Route path="/humanpayouts" element={<HumanPayouts/>} />

          <Route path="daisypayoutsmainpage" element={<DaisyPayoutsMainPage/>} />
          <Route path="daisyintervals" element={<DaisyDepositInterval/>} />
          <Route path="daisyintervalscontracts" element={<DaisyDepositInvervalContractList/>} />

          <Route path="payouts" element={<DaisyPayoutManager/>}/>
          <Route path="totalpayouts" element={<TotalDaisyPayoutManager/>}/>
          <Route path="votelabels" element={<VoteLabelManager/>}/>
          <Route path="newsletterlist" element={<NewsLetterManagerList/>}/>
          <Route path="newsletterviewers" element={<NewsLetterViewers/>}/>
          <Route path="newslettersubscriptionhandling/:id" element={<NewsLetterSubscriptionHandler/>}/> 
          <Route path="group-connections" element={<GroupConnectionsList />} />
          <Route path="miningproductions" element={<MiningProductionDashboardPage />} />
          <Route path="returnpage" element={<ReturnAfterDocuSignPage />} />
          <Route path="3ybtc" element={<LargeBitcoinChartPage />} />
          <Route path="bs" element={<BlockchainSportsAdminPage />} />
          <Route path="captioncreator" element={<DashboardCaptionCreator />} />
          <Route path="bmp" element={<BMPDashboard />} />
          <Route path="/acchandler/:id" element={<AccountHandling/>} />
          <Route path="/usermap" element={<UserMap/>} />
          <Route path="/meetings" element={<MeetingList/>} />
          <Route path="/acchandler/:id" element={<DaisyEurRatesPage/>} />
          <Route path="daisyeurrates" element={<DaisyEurRatesPage />} />
          <Route path="daisyatlaoptions" element={<DaisyAtlaOptionsPage />} />
          <Route path="task" element={<TaskPage />} />

          <Route path="envelopes" element={<ContractHistory archivedListOpen={false}/>} />
        </> 
        : null }
      </Route>
      
      <Route path="*" element={<NoPage />} />
    </Routes>
  )
}